import { jsPDF } from 'jspdf';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import frenchlan from '../../../french.json';
import malayalamlan from '../../../malayalam.json';

const loadImageAsBase64 = (urls1) => {
	// Load images from both arrays concurrently
	const loadFromArray = (urls) => {		
		return Promise.all(
			urls && urls.map((url) => {
				return new Promise((resolve, reject) => {
					const img = new Image();
					img.crossOrigin = 'Anonymous';  // Allow cross-origin images
					img.onload = () => {
						const canvas = document.createElement('canvas');
						canvas.width = img.width;
						canvas.height = img.height;
						const ctx = canvas.getContext('2d');
						ctx.drawImage(img, 0, 0);
						const base64Data = canvas.toDataURL('image/jpeg'); // You can change to PNG or other formats
						resolve(base64Data);
					};
					img.onerror = (error) => reject(error);
					img.src = url;
				});
			})
		);
	};
  
	// Load both arrays of images concurrently
	return Promise.all([loadFromArray([urls1])]);
};

const DownloadPDF = (jsonData, batchNo) => {

	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? englan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? englan : langid == 6 ? malayalamlan : englan;

	const generatePDF = async () => {
		if (!jsonData || jsonData.length === 0) return;
    
		// Create a new jsPDF instance
		const pdf = new jsPDF();
    
		// Define the initial Y position
		let yPosition = 20;
		const pageHeight = pdf.internal.pageSize.height;
		// const pageHeight = 250;
        
		// Title and initial setup
		pdf.setFontSize(20);
		pdf.text( langdata && langdata.UsersList ? langdata.UsersList : 'User List', 10, yPosition);
		yPosition += 10; // Adjust the starting position for content
            
        
		// Set font for table data
		pdf.setFontSize(10);
    
		// Create the table headers (if necessary)
		// Prepare an array of promises to load images
		const imagePromises = jsonData.map((item) => {
			return loadImageAsBase64(item && item.profileImageUrl && item.profileImageUrl).then(([profilebase64Image]) => {				
				return {
					id: item.id.toString(),
					firstName: item.firstName,
					lastName: item.lastName,
					profilebase64Image,
					email: item.email,
					cellPhone: item.cellPhone,
					usertype: item.usertype,
					
				};
			}).catch(() => {
				// Handle image load failure gracefully
				return {
					id: item.id.toString(),
					firstName: item.firstName,
					lastName: item.lastName,
					profilebase64Image: null,
					email: item.email,
					cellPhone: item.cellPhone,
					usertype: item.usertype,
				};
			});
		});
    
		// Wait for all image loading promises to complete
		const imageDataArray = await Promise.all(imagePromises);
    
		// Loop through the data and add rows to the table
		let count = 1;
		for (const {
			id,
			firstName,
			lastName,
			profilebase64Image,
			email,
			cellPhone,
			usertype,
		} of imageDataArray) {

			pdf.setFontSize(14);
			pdf.text(`User ${count}`, 10, yPosition);
			yPosition += 10;
			pdf.setFontSize(10);
			// Add sections for alarm details
			// pdf.setFontSize(16);
			// pdf.text('Details', 10, yPosition);
			// yPosition += 10;

			// pdf.setFontSize(16);
			// pdf.text('Profile Image', 10, yPosition);
			// pdf.setFontSize(10);
			// yPosition += 10;
                
			if (profilebase64Image) {
				if (yPosition + 20 > pageHeight) {
					pdf.addPage();
					yPosition = 10;
				}
    
				// yPosition = 40;
				let xPosition = 10;
				profilebase64Image && profilebase64Image.map((image) => {					
					let imageFormat = image.includes('image/png') ? 'PNG' : 'JPEG';
					pdf.addImage(image, imageFormat, xPosition, yPosition - 5, 20, 20);
					xPosition += 40;
					if(xPosition > 160){
						yPosition += 40;
						xPosition = 40;
					}
					if (yPosition + 20 > pageHeight) {
						pdf.addPage();
						yPosition = 10;
					}
				});				
				yPosition += 40;
			} 
			// else {
			// 	pdf.text(langdata && langdata.NoProfileImage ? langdata.NoProfileImage : 'No Profile Image', 10, yPosition);
			// 	yPosition += 20;
			// }
    
			if (yPosition > pageHeight) {
				pdf.addPage();
				yPosition = 10; // Reset yPosition when adding a new page
			}
			
			
			pdf.text(langdata && langdata.ID ? langdata.ID : 'ID', 10, yPosition);
			if (id) {
				pdf.text(': ' + id, 30, yPosition);
			}
			yPosition += 10;
    
			if (yPosition > pageHeight) {
				pdf.addPage();
				yPosition = 10; // Reset yPosition when adding a new page
			}
    
			pdf.text(langdata && langdata.FirstName ? langdata.FirstName : 'First Name', 10, yPosition);
			if (firstName) {
				pdf.text(': ' + firstName, 30, yPosition);
			}
			yPosition += 10;
    
			if (yPosition > pageHeight) {
				pdf.addPage();
				yPosition = 10; // Reset yPosition when adding a new page
			}
    
			pdf.text(langdata && langdata.LastName ? langdata.LastName : 'Last Name',10, yPosition);
			if (lastName) {
				pdf.text(': ' + lastName, 30, yPosition);
			}
			yPosition += 10;
    
			if (yPosition > pageHeight) {
				pdf.addPage();
				yPosition = 10; // Reset yPosition when adding a new page
			}
    
			pdf.text(langdata && langdata.Email ? langdata.Email : 'Email',10, yPosition);
			if (email) {
				pdf.text(': ' + email, 30, yPosition);
			}
			yPosition += 10;
    
			if (yPosition > pageHeight) {
				pdf.addPage();
				yPosition = 10; // Reset yPosition when adding a new page
			}
    
			pdf.text(langdata && langdata.Phone ? langdata.Phone : 'Phone', 10, yPosition);
			if (cellPhone) {
				pdf.text(': ' + cellPhone, 30, yPosition);
			}
			yPosition += 10;
			
			if (yPosition > pageHeight) {
				pdf.addPage();
				yPosition = 10; // Reset yPosition when adding a new page
			}
			pdf.text(langdata && langdata.UserType ? langdata.UserType : 'User Type', 10, yPosition);
			if (cellPhone) {
				pdf.text(': ' + usertype, 30, yPosition);
			}
			yPosition += 20;
    
			if (yPosition > pageHeight) {
				pdf.addPage();
				yPosition = 10; // Reset yPosition when adding a new page
			}
    
						
                
			count++;
		}
    
		// Save the generated PDF
		pdf.save(`${langdata && langdata.UsersList ? langdata.UsersList :'Users-List'}-${batchNo + 1}.pdf`);	
	};
    
	generatePDF();

	return null; // No UI rendered for this component
};

export default DownloadPDF;
